export const mapGtmProduct = ({ products, seller }) => {
  if (products?.length === 0) return null;

  return products?.map((item, index) => ({
    item_id: item.product.id,
    item_name: item.product.name,
    quantity: item.quantity,
    price: item.product.price,
    affiliation: seller?.name || undefined,
    discount: item?.valorDesconto || undefined,
    index,
  }));
};
